<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>
    <a [routerLink]="['/tasks/activated']">Activated Tasks</a>
  </li>
  <li>
    Update Activated Task
  </li>
</ul>
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Task Details</strong>
    </span>
    <button type="button" class="btn btn-sm btn-default pull-right btn-back" (click)="ShowActivatedTasks()">
      <i class="fa fa-chevron-circle-left"></i>&nbsp;Back
    </button>

  </div>
  <div class="card-block">
    <div class="row">
      <div class="col-lg-12">
        <div class="margin-bottom-50">

          <form [formGroup]="activatedTaskForm" class="well">
            <div class="modal-content">
              <div class="modal-body" style="position: relative;">
                <div class="update-task-loader-overlay" *ngIf="isUploading || isPageLoading">
                  <div class="update-task-loader-container">
                    <img src="assets/images/DigiCompany_loader.png" class="update-task-spinner" alt="Loading..." />
                  </div>
                </div>
                <!-- First Block: Trigger Type, Statutory/Internal, Risk Profile, Date Option, Meeting Type -->
                <div class="form-block-row">
                  <div class="row">
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label">Trigger Type
                        <span style="color: red;">*</span>
                      </label>
                      <div class="form-group form-block-input">
                        <div class="md-radio md-radio-inline">
                          <input id="IsPeriodic" type="radio" [formControl]="activatedTaskForm.controls['TriggerType']"
                            (click)="CheckTriggerType('Periodic')" style="position:absolute" name="TriggerType"
                            value="Periodic" class="form-check-input" disabled>
                          <label for="IsPeriodic">Periodic</label>
                        </div>
                        <div class="md-radio md-radio-inline">
                          <input id="IsEvent" type="radio" [formControl]="activatedTaskForm.controls['TriggerType']"
                            (click)="CheckTriggerType('Event')" style="position:absolute" name="TriggerType" value="Event"
                            class="form-check-input" disabled>
                          <label for="IsEvent">Event</label>
                        </div>
                        <div
                          *ngIf="activatedTaskForm.controls['TriggerType'].hasError('required') && (activatedTaskForm.controls['TriggerType'].dirty || activatedTaskForm.controls['TriggerType'].pristine)"
                          class="form-control-error-custom">
                          Please Select Either Periodic Or Event.
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 form-block-cell" *ngIf="IsTriggerTypeSelected('Event') || IsTriggerTypeSelected('Periodic')">
                      <label class="form-control-label form-block-label">Trigger ID
                        <!-- <span style="color: red;">*</span> -->
                      </label>
                      <div class="form-group form-block-input">
                        <select [formControl]="activatedTaskForm.controls['tasktriggerId']"
                          class="form-control select">
                          <option value="">Select</option>
                          <option *ngFor="let taskTriggerType of taskTriggerTypes" value={{taskTriggerType._id}}>
                            {{taskTriggerType.Name}}
                          </option>
                        </select>
                        <!-- <div
                          *ngIf="activatedTaskForm.controls['tasktriggerId'].hasError('required') && (activatedTaskForm.controls['tasktriggerId'].dirty || activatedTaskForm.controls['tasktriggerId'].pristine)"
                          class="form-control-error-custom">
                          Task Trigger type is required.
                        </div> -->
                      </div>
                    </div>
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label">Statutory/Internal</label>
                      <div class="form-group form-block-input">
                        <select class="form-control" [formControl]="activatedTaskForm.controls['policytypeId']">
                          <option value="">Select</option>
                          <option *ngFor="let policytype of policyTypes" value={{policytype.id}}>{{policytype.name}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <!-- Specific Date directly under Trigger Type / Trigger ID row -->
                  <div class="row" *ngIf="checkTriggerId(activatedTaskForm.controls['tasktriggerId'].value)">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label">Specific Date</label>
                      <div class="form-group form-block-input">
                        <div class="input-group" (click)="$event.stopPropagation()">
                          <app-datepicker-material [formControl]="activatedTaskForm.controls['fixedDate']"
                            [(ngModel)]="fixedDateDateModel" [placeholder]="'dd-mm-yyyy'" [disabled]="false">
                          </app-datepicker-material>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label">Consequences Type
                        <span style="color: red;">*</span>
                      </label>
                      <div class="form-group form-block-input form-block-input-center">
                        <div class="radio-container">
                          <label class="md-radio-inline">
                            <input type="radio" value="SystemDefined" [formControl]="activatedTaskForm.controls['ConsequencesType']" name="consequencesType"> System Defined
                          </label>
                          <label class="md-radio-inline">
                            <input type="radio" value="UserDefined" [formControl]="activatedTaskForm.controls['ConsequencesType']" name="consequencesType"> User Defined
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Consequences Type (after Specific Date, same block style) -->
                 
                    <div class="row" *ngIf="IsTriggerTypeSelected('Periodic')">
                      <div class="col-md-6 form-block-cell">
                        <label class="form-control-label form-block-label">Trigger Date
                          <span style="color: red;">*</span>
                        </label>
                        <div class="form-group form-block-input">
                          <div class="input-group" (click)="$event.stopPropagation()">
                            <app-datepicker-material
                              [formControl]="activatedTaskForm.controls['TriggerStartingDate']"
                              [(ngModel)]="TriggerStartingDateModel" [placeholder]="'dd-mm-yyyy'"
                              [minDate]="minimumDate" [disabled]="true"
                              (ngModelChange)="dateOfEndDateChangeEvent()">
                            </app-datepicker-material>
                          </div>
                        </div>
                      </div>
                    </div>
                 
                  <div class="row">
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label">Risk Profile</label>
                      <div class="form-group form-block-input">
                        <select [formControl]="activatedTaskForm.controls['risktypeId']" class="form-control select">
                          <option value="">Select</option>
                          <option *ngFor="let riskType of riskTypes" value={{riskType.id}}> {{riskType.name}} </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-4 form-block-cell" *ngIf="IsTriggerTypeSelected('Event') || IsTriggerTypeSelected('Periodic')">
                      <label class="form-control-label form-block-label">Date Option
                        <span style="color: red;">*</span>
                      </label>
                      <div class="form-group form-block-input">
                        <select [formControl]="activatedTaskForm.controls['DateOption']"
                          class="form-control select">
                          <option value="">Select</option>
                          <option *ngFor="let dateOption of dateOptions" value={{dateOption.id}}>
                            {{dateOption.name}}
                          </option>
                        </select>
                        <div
                          *ngIf="activatedTaskForm.controls['DateOption'].hasError('required') && (activatedTaskForm.controls['DateOption'].dirty || activatedTaskForm.controls['DateOption'].pristine)"
                          class="form-control-error-custom">
                          Please Select Date option.
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label">Meeting Type</label>
                      <div class="form-group form-block-input">
                        <select [formControl]="activatedTaskForm.controls['meetingtypeId']" class="form-control select">
                          <option value="">None</option>
                          <option *ngFor="let meetingType of meetingTypes" value={{meetingType._id}}>
                            {{meetingType.MeetingType}} </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Second Block: Task Name, Task Description, Tag, Email Contents -->
                <div class="form-block-row">
                  <div class="row">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label">Task
                        <span style="color: red;">*</span>
                      </label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <input [formControl]="activatedTaskForm.controls['TaskName']" class="form-control">
                        <div
                          *ngIf="(activatedTaskForm.controls['TaskName'].hasError('required')  || activatedTaskForm.controls['TaskName'].hasError('whitespace')) && (activatedTaskForm.controls['TaskName'].dirty || activatedTaskForm.controls['TaskName'].pristine)"
                          class="form-control-error-custom">
                          The task name is required.
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label">Tag
                        <span style="color: red;">*</span>
                      </label>
                      <div class="form-group form-block-input">
                        <select [formControl]="activatedTaskForm.controls['groupId']" class="form-control select">
                          <option value="">Select</option>
                          <option *ngFor="let group of groupTypes" value={{group._id}}>
                            {{group.GroupName}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label">Task Description
                        <span style="color: red;">*</span>
                      </label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <textarea [formControl]="activatedTaskForm.controls['TaskDescription']" class="form-control"
                          rows="3"></textarea>
                        <div
                          *ngIf="(activatedTaskForm.controls['TaskDescription'].hasError('required') || activatedTaskForm.controls['TaskName'].hasError('whitespace')) && (activatedTaskForm.controls['TaskDescription'].dirty || activatedTaskForm.controls['TaskDescription'].pristine)"
                          class="form-control-error-custom">
                          Task description is required.
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label">Email Contents</label>
                      <div class="form-group form-block-input">
                        <textarea [formControl]="activatedTaskForm.controls['EmailContents']"
                          class="form-control" rows="3">
                        </textarea>
                      </div>
                    </div>
                  </div>
                </div>
              


                <!-- Block: System Defined Consequences + Upload File | User Defined Consequences + Emails -->
                <div class="form-block-row">
                  <div class="row">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label">System Defined Consequences</label>
                      <div class="form-group form-block-input">
                        <textarea [formControl]="activatedTaskForm.controls['PreConsequences']" class="form-control"
                          rows="4" readonly style="background-color: #f8f9fa; resize: vertical;"></textarea>
                      </div>
                      <label class="form-control-label form-block-label" style="margin-top: 16px;">Upload File</label>
                      <div class="form-group form-block-input form-block-input-center">
                        <div class="row form-block-upload-row">
                          <div class="col-md-6 upload-file-input-wrap" *ngIf="imageEdit">
                            <input type="text" [formControl]="activatedTaskForm.controls['DocumentFile']"
                              class="form-control upload-file-input" readonly="true">
                          </div>
                          <div class="col-md-6 upload-file-input-wrap" *ngIf="imageAdd">
                            <input type="hidden" [formControl]="activatedTaskForm.controls['DocumentFile']">
                            <input type="file" class="form-control upload-file-input" (change)="onFileChanged($event)"
                              accept=".xlsx, .xls, .doc, .docx, .pdf" />
                          </div>
                          <div class="col-md-2" *ngIf="imageAddRev">
                            <button type="button" class="btn-sm btn btn-default" (click)="revert()">
                              <span class="fa fa-refresh"></span>
                            </button>
                          </div>
                          <div class="col-md-2" *ngIf="imageEdit">
                            <button *ngIf="imageEdit && selectedFileName" type="button" class="btn-sm btn btn-warning"
                              (click)="downloadDocTask()">
                              <span class="fa fa-download"></span>
                            </button>
                            <button type="button" class="btn-sm btn btn-primary" (click)="addNewDoc()">
                              <i class="fa fa-plus"></i>Add New files
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label">User Defined Consequences</label>
                      <div class="form-group form-block-input">
                        <textarea [formControl]="activatedTaskForm.controls['UserConsequences']" class="form-control"
                          rows="4" style="resize: vertical;"></textarea>
                      </div>
                      <label class="form-control-label form-block-label" style="margin-top: 16px;">Emails</label>
                      <div class="form-group form-block-input form-block-input-center">
                        <div class="radio-container">
                          <label class="md-radio-inline">
                            <input type="radio" [value]="true" [formControl]="activatedTaskForm.controls['Email']" name="emailToggle"> ON
                          </label>
                          <label class="md-radio-inline">
                            <input type="radio" [value]="false" [formControl]="activatedTaskForm.controls['Email']" name="emailToggle"> OFF
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Block: Assigned To, Colleague, Due Date, Reminder Start Date, Reminder Frequency -->
                <div class="form-block-row">
                  <div class="row">
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Assigned To</label>
                      <div class="form-group form-block-input">
                        <ng-select [items]="assignedusers" [multiple]="true" bindLabel="label" bindValue="value"
                          placeholder="Select User" [formControl]="activatedTaskForm.controls['AssignedTo']"
                          (change)="onSelectMemberDisableFromOther(true)" class="form-control m-b-10 p-8"
                          style="padding: 0px; text-align:left;">
                        </ng-select>
                      </div>
                    </div>
                    <div class="col-md-6 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Colleague</label>
                      <div class="form-group form-block-input">
                        <ng-select [items]="collegues" [multiple]="true" bindLabel="label" bindValue="value"
                          placeholder="Select collegue" [formControl]="activatedTaskForm.controls['Collegues']"
                          (change)="onSelectMemberDisableFromOther()" class="form-control m-b-10 p-8"
                          style="padding: 0px; text-align:left;">
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Due Date</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <app-datepicker-material [formControl]="activatedTaskForm.controls['CompletionDate']"
                          [placeholder]="'dd-mm-yyyy'" [disabled]="false">
                        </app-datepicker-material>
                      </div>
                    </div>
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Reminder Start Date</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <app-datepicker-material [formControl]="activatedTaskForm.controls['ReminderDate']"
                          [placeholder]="'dd-mm-yyyy'" [disabled]="false" [minDate]="null" [maxDate]="EndDateModel" (click)="$event.stopPropagation()">
                        </app-datepicker-material>
                        <div
                          *ngIf="activatedTaskForm.controls['ReminderDate'].hasError('reminderBeforeBase') && activatedTaskForm.controls['ReminderDate'].touched"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Reminder start date cannot be earlier than the trigger start date or fixed date.
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">Reminder Frequency (Days)</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <input [formControl]="activatedTaskForm.controls['ReminderFrequency']" class="form-control"
                          [OnlyNumber]=true (input)="checkRemindersValidation()">
                        <div
                          *ngIf="activatedTaskForm.controls['ReminderFrequency'].hasError('max') && activatedTaskForm.controls['ReminderFrequency'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please enter a maximum 30 days.
                        </div>
                        <div
                          *ngIf="activatedTaskForm.controls['ReminderFrequency'].hasError('min') && activatedTaskForm.controls['ReminderFrequency'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Reminder Frequency (days) cannot be negative.
                        </div>
                        <div id="ErrorreminderFrequency" *ngIf="reminderFrequencyError.isError"
                          style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          {{ reminderFrequencyError.errorMessage }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Block: Escalation (with header and expand/collapse) -->
                <div class="form-block-row escalation-block">
                  <div class="escalation-header d-flex align-items-center justify-content-between px-3 py-2 cursor-pointer"
                    (click)="escalationBlockCollapsed = !escalationBlockCollapsed">
                    <h5 class="mb-0">Escalation</h5>
                    <i class="fa fa-chevron-up" [class.fa-chevron-down]="escalationBlockCollapsed" aria-hidden="true"></i>
                  </div>
                  <div *ngIf="!escalationBlockCollapsed">
                  <div class="row">
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">1st Escalation</label>
                      <div class="form-group form-block-input">
                        <ng-select [items]="escalation1Users" [multiple]="true" bindLabel="label"
                          bindValue="value" placeholder="Select"
                          [formControl]="activatedTaskForm.controls['Escalation1ofAssignedTo']"
                          (change)="onSelectMemberDisableFromOther()" class="form-control m-b-10 p-8"
                          style="padding: 0px; text-align:left;">
                        </ng-select>
                      </div>
                    </div>
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">1st Escalation Start</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <input [formControl]="activatedTaskForm.controls['EscalationDays']"
                          class="form-control" (input)="checkRemindersValidation()" [OnlyNumber]=true>
                        <div
                          *ngIf="activatedTaskForm.controls['EscalationDays'].hasError('max') && (activatedTaskForm.controls['EscalationDays'].dirty || activatedTaskForm.controls['EscalationDays'].pristine)"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please enter a maximum 30 days.
                        </div>
                        <div
                          *ngIf="activatedTaskForm.controls['EscalationDays'].hasError('min') && activatedTaskForm.controls['EscalationDays'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          1st Escalation Start cannot be negative.
                        </div>
                        <div id="ErrorfirstEscalationStart" *ngIf="firstEscalationStartError.isError"
                          style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          {{ firstEscalationStartError.errorMessage }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">1st Escalation reminder frequency</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <input [formControl]="activatedTaskForm.controls['ReminderFrequencyLevel1']"
                          class="form-control" (input)="checkRemindersValidation()" [OnlyNumber]=true>
                        <div
                          *ngIf="activatedTaskForm.controls['ReminderFrequencyLevel1'].hasError('max') && (activatedTaskForm.controls['ReminderFrequencyLevel1'].dirty || activatedTaskForm.controls['ReminderFrequencyLevel1'].pristine)"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please enter a maximum 30 days.
                        </div>
                        <div
                          *ngIf="activatedTaskForm.controls['ReminderFrequencyLevel1'].hasError('min') && activatedTaskForm.controls['ReminderFrequencyLevel1'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          1st Escalation reminder frequency cannot be negative.
                        </div>
                        <div id="ErrorfirstEscalationreminderFrequency"
                          *ngIf="firstEscalationreminderFrequencyError.isError"
                          style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          {{ firstEscalationreminderFrequencyError.errorMessage }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">2nd Escalation</label>
                      <div class="form-group form-block-input">
                        <ng-select [items]="escalation2Users" [multiple]="true" bindLabel="label"
                          bindValue="value" placeholder="Select"
                          [formControl]="activatedTaskForm.controls['Escalation2ofAssignedTo']"
                          (change)="onSelectMemberDisableFromOther()" class="form-control m-b-10 p-8"
                          style="padding: 0px; text-align:left;">
                        </ng-select>
                      </div>
                    </div>
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">2nd Escalation Start</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <input [formControl]="activatedTaskForm.controls['Level2EscalationDays']"
                          class="form-control" (input)="checkRemindersValidation()" [OnlyNumber]=true>
                        <div
                          *ngIf="activatedTaskForm.controls['Level2EscalationDays'].hasError('max') && (activatedTaskForm.controls['Level2EscalationDays'].dirty || activatedTaskForm.controls['Level2EscalationDays'].pristine)"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please enter a maximum 30 days.
                        </div>
                        <div
                          *ngIf="activatedTaskForm.controls['Level2EscalationDays'].hasError('min') && activatedTaskForm.controls['Level2EscalationDays'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          2nd Escalation Start cannot be negative.
                        </div>
                        <div id="ErrorsecondEscalationStart" *ngIf="secondEscalationStartError.isError"
                          style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          {{ secondEscalationStartError.errorMessage }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 form-block-cell">
                      <label class="form-control-label form-block-label" for="l0">2nd Escalation reminder frequency</label>
                      <div class="form-group form-block-input" style="position: relative;">
                        <input [formControl]="activatedTaskForm.controls['ReminderFrequencyLevel2']"
                          class="form-control" (input)="checkRemindersValidation()" [OnlyNumber]=true>
                        <div
                          *ngIf="activatedTaskForm.controls['ReminderFrequencyLevel2'].hasError('max') && (activatedTaskForm.controls['ReminderFrequencyLevel2'].touched || activatedTaskForm.controls['ReminderFrequencyLevel2'].pristine)"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          Please enter a maximum 30 days.
                        </div>
                        <div
                          *ngIf="activatedTaskForm.controls['ReminderFrequencyLevel2'].hasError('min') && activatedTaskForm.controls['ReminderFrequencyLevel2'].dirty"
                          class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          2nd Escalation reminder frequency cannot be negative.
                        </div>
                        <div id="ErrorsecondEscalationreminderFrequency"
                          *ngIf="secondEscalationreminderFrequencyError.isError"
                          style="color: #fb434a;font-size: 80%;z-index: 1; position: absolute; top: 100%; left: 0; white-space: nowrap;">
                          {{ secondEscalationreminderFrequencyError.errorMessage }}
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>

                  <!-- Block: Responsible User (three columns with vertical separators) -->
                  <div class="form-block-row form-block-row-responsible-user">
                    <div class="row">
                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">Responsible User</label>
                        <div class="form-group form-block-input">
                          <ng-select [items]="responsibleUsers" [multiple]="true" bindLabel="label"
                            bindValue="value" placeholder="Select"
                            [formControl]="activatedTaskForm.controls['ResponsibleUser']"
                            (change)="onSelectMemberDisableFromOther()" class="form-control m-b-10 p-8"
                            style="padding: 0px; text-align:left;">
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">Responsible User 1st Escalation</label>
                        <div class="form-group form-block-input">
                          <ng-select [items]="escalation1ofResponsibleUsers" [multiple]="true" bindLabel="label"
                            bindValue="value" placeholder="Select"
                            [formControl]="activatedTaskForm.controls['Escalation1ofResponsibleUser']"
                            (change)="onSelectMemberDisableFromOther()" class="form-control m-b-10 p-8"
                            style="padding: 0px; text-align:left;">
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">Responsible User 2nd Escalation</label>
                        <div class="form-group form-block-input">
                          <ng-select [items]="escalation2ofResponsibleUsers" [multiple]="true" bindLabel="label"
                            bindValue="value" placeholder="Select"
                            [formControl]="activatedTaskForm.controls['Escalation2ofResponsibleUser']"
                            (change)="onSelectMemberDisableFromOther()" class="form-control m-b-10 p-8"
                            style="padding: 0px; text-align:left;">
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Block: Task Status, Task Remarks, Task Particulars (3 columns); Completed Date on second row when status = Completed -->
                  <div class="form-block-row">
                    <div class="row">
                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">Task Status</label>
                        <div class="form-group form-block-input">
                          <select [formControl]="activatedTaskForm.controls['TaskStatus']" class="form-control select"
                            [(ngModel)]="TaskStatusModel" (change)="TaskStatusChange($event)">
                            <option *ngFor="let taskStatus of taskStatusTypes" [disabled]="taskStatus.isDisabled"
                              value={{taskStatus.id}}>
                              {{taskStatus.name}}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">Task Remarks</label>
                        <div class="form-group form-block-input">
                          <input [formControl]="activatedTaskForm.controls['TaskRemarks']" class="form-control">
                        </div>
                      </div>
                      <div class="col-md-4 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">Task Particulars
                          <span style="color: red;">*</span>
                        </label>
                        <div class="form-group form-block-input" style="position: relative;">
                          <textarea [formControl]="activatedTaskForm.controls['TaskParticulars']" class="form-control"
                            rows="3" style="resize: vertical;"></textarea>
                          <div
                            *ngIf="(activatedTaskForm.controls['TaskParticulars'].hasError('required') || activatedTaskForm.controls['TaskParticulars'].hasError('whitespace')) && (activatedTaskForm.controls['TaskParticulars'].dirty || activatedTaskForm.controls['TaskParticulars'].pristine)"
                            class="form-control-error-custom">
                            Task particulars is required.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" *ngIf="(TaskStatusModel!= undefined && TaskStatusModel==2)">
                      <div class="col-md-12 form-block-cell">
                        <label class="form-control-label form-block-label" for="l0">Completed Date</label>
                        <div class="form-group form-block-input" style="position: relative;">
                          <app-datepicker-material [formControl]="activatedTaskForm.controls['CompletedDate']"
                            [(ngModel)]="CompletedDateModel" [placeholder]="'dd-mm-yyyy'" [maxDate]="todaysDate"
                            [disabled]="false">
                          </app-datepicker-material>
                          <div *ngIf="TaskStatusModel === 2 &&
                            activatedTaskForm.controls['CompletedDate'].hasError('required') &&
                            activatedTaskForm.controls['CompletedDate'].touched" class="form-control-error-custom" style="position: absolute; top: 100%; left: 0; white-space: nowrap;">
                            Please Select Date.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </div>
              <div class="modal-footer">
                <button id="btnsaveTask" type="button" class="btn btn-sm btn-primary"
                  [disabled]="!activatedTaskForm.valid || disabledOnclick" (click)="updateActivatedTask()"
                  [appHasPermission]="[
                      { 'Url': '/tasks/activatedAll/edit?goveva=true&email=', 'method':'put', 'menu': 'ActivatedTaskAll' },
                      { 'Url': '/tasks/activatedIndividual/edit?goveva=true&email=', 'method':'put', 'menu': 'ActivatedTaskIndividual' }
                    ]">
                  <i class="fa fa-save"></i>&nbsp;Update
                </button>
                <span style="float: right">
                  <button class="btn btn-sm btn-primary" type="button" data-toggle="modal"
                    [appHasPermission]="[{'Url': '/tasks/activatedAll/edit?goveva=true&email=', 'method':'put', 'menu': 'ActivatedTaskAll'},
                    {'Url': '/tasks/activatedIndividual/edit?goveva=true&email=', 'method':'put', 'menu': 'ActivatedTaskIndividual'}]" (click)="initiateUploadProof()">

                    <i class="fa fa-save"></i>&nbsp;Upload Proof</button></span>
                <span *ngIf="documentId" style="float: right">
                  <button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#confirmation" type="button"
                    [appHasPermission]="[{'Url': '/tasks/activatedAll/edit?goveva=true&email=', 'method':'put', 'menu': 'ActivatedTaskAll'},
                    {'Url': '/tasks/activatedIndividual/edit?goveva=true&email=', 'method':'put', 'menu': 'ActivatedTaskIndividual'}]">
                    <i class="fa fa-trash"></i>&nbsp;Delete Proof</button></span>

                <a *ngIf="documentId" href="{{downloadLink}}{{documentId}}/{{token}}" target="_blank"
                  class="btn btn-sm btn-primary">
                  <span class="fa fa-download"></span>
                </a>
              </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
    aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>&nbsp;Confirm
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete the Proof?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deleteProof(documentId)">
            <i class="fa fa-check"></i> &nbsp;Yes</button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i> &nbsp;No</button>

        </div>
      </div>
    </div>
  </div>

  <div class="modal fade modal-size-medium" id="uploadProofDialog" tabindex="-1" role="dialog" aria-labelledby=""
    aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form [formGroup]="uploadProofactivatedTaskForm" class="well">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel">Upload Proof</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-2">
                <label class="col-form-label" for="l5">Proof </label>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input class="form-control" id="avatar" type="file"
                    [formControl]="uploadProofactivatedTaskForm.controls['fileData']" (change)="onFileChange($event)"
                    accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf,.pptx, .ppt, .mp4">
                  <div *ngIf="!IsSelectedUpload" class="form-control-error-custom">
                    Document is required to upload.
                  </div>
                  <span style="color: red" *ngIf="!isExtensionTrue">
                    Please upload valid file format.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button id="btnUploadProof" type="button" class="btn btn-sm btn-primary"
              [disabled]="!IsSelectedUpload || disabledOnclick || !isExtensionTrue" (click)="uploadProofDocument()"><i
                class="fa fa-save"></i>&nbsp;Upload</button>
            <button type="button" class="btn btn-sm" data-dismiss="modal"> <i
                class="fa fa-times"></i>&nbsp;Close</button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="modal fade modal-size-large" id="uploadProofDialog1" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <em class="fa fa-upload"></em>
            <span id="uploadProofDialogTitle"></span>
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <em class="fa fa-times"></em>
          </button>
        </div>
        <div class="modal-body">
          <span class="cat__core__title">
            Existing Files
          </span>

          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="groupTable"
            class="table table-hover compact cell-border nowrap stripe" style="cursor: pointer;">
            <caption></caption>
            <thead>
              <tr>

                <th scope="head">Filename</th>
                <th scope="head">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let proof of taskProofData; let count=index">

                <td tabindex="1" style="cursor: move; width: 70%;">
                  {{proof.DocName}}
                </td>
                <td>
                  <button type="button" class="btn-sm btn btn-warning"
                    (click)="downloadDoc(proof.DocumentManagementID)">
                    <span class="fa fa-download"></span>
                  </button>
                  <button type="button" class="btn-sm btn btn-danger"
                    (click)="deleteProofDoc(proof._id,proof.DocumentManagementID)">
                    <span class="fa fa-close"></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col-md-4">
              <label class="col-form-label" for="l5">
                <span>Upload Proof
                  <span _ngcontent-c2="" style="color: red;">*</span>
                </span>
              </label>
            </div>
            <div class="col-md-8">
              <div class="form-group">
                <input type="file" class='form-control fileUpload' (change)="proofChangeEvent($event)"
                  accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx" multiple />
                <span *ngIf="typeHasError" style="color: red">
                  Please upload valid file format.
                </span>

              </div>
              <!-- {{fileHasError | json}} -->
            </div>
          </div>

          <!-- </div>
            </div> -->
        </div>
        <div class="modal-footer">

          <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary" (click)="uploadProofFile()">
            <em class="fa fa-save"></em>&nbsp;Upload</button>

          <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
            <em class="fa fa-times"></em>&nbsp;Close</button>

        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="deletePdfConfirmation" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDeletion">
            <em class="fa fa-question-circle-o mr-2"></em>Confirm
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <em class="fa fa-times"></em>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete this proof document?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="removeDoc()" data-dismiss="modal">
            <em class="fa fa-check"></em>&nbsp;Yes</button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <em class="fa fa-times"></em>&nbsp;No</button>
        </div>
      </div>
    </div>
  </div>

</section>
<app-alert></app-alert>